import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import MediaQuery from 'react-responsive'
import { selectViewport } from 'services/viewport/selectors'
import isServer from 'shared/isServer'

const mapStateToProps = state => {
  return {
    viewport: selectViewport(state),
  }
}

const MediaQueryWrapper = props => {
  const { viewport, dispatch, ...newProps } = props // eslint-disable-line no-unused-vars, react/prop-types

  if (isServer()) {
    newProps.values = viewport
  }

  return (
    <MediaQuery {...newProps}>
      {props.children}
    </MediaQuery>
  )
}

MediaQueryWrapper.propTypes = {
  viewport: PropTypes.object,
  children: PropTypes.node,
}

export default connect(mapStateToProps)(MediaQueryWrapper)
